import React from 'react';
import { cn } from '@anytag/shared-utils';
import { DrawerFooter } from '../shadcn-blocks/drawer';
import { Drawer as Root } from './Drawer';

export const Drawer = {
  Root,
  Body: ({ className, ...restProps }: React.ComponentProps<'div'>) => (
    <div className={cn('drawer-content p-6', className)} {...restProps} />
  ),
  Footer: ({ className, ...resrtProps }: React.ComponentProps<'div'>) => (
    <DrawerFooter className={cn('p-0', className)} {...resrtProps} />
  )
};
